// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/icons/chevron-down.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --light-grey-rgb: 214, 214, 214;
    --light-grey: #d6d6d6;
    --dark-grey: #7b848e;
    /*border: #707070*/
    --white-active: #fbfbfb;

    --light-grey-blue: #f2f3f4;

    --primary-color: #1650b4;
    --primary-color-active: #0c3b8d;

    --primary-color-light: #f0f3f7;

    --secondary-color: #ff6f00;
    --secondary-color-active: #bc5200;

    --secondary-light-color: #16a9fd;
    --secondary-light-color-active: #1294f0;

    --hightlight-color: #1b53b1;

    --alert-color: #cf3b30;

    --success-color: #3b7f57;

    --font: 'Roboto', sans-serif;
    --font-secondary: 'Koh Santepheap', cursive;

    --container-width: 1880px;
    --container-padding: 30px;
    --container-margin: 35px;

    --header-height: 100px;
    --header-padding-sides: 40px;
    --header-padding-bottom: 0px;

    --header-logo-width: 211px;

    --sidebar-collapsed-width: 60px;
    --sidebar-expanded-width: 300px;

    --folder-gap: 50px;
    --folder-item-gap: 20px;
}

html,
body {
    margin: 0;
    padding: 0;
    min-height: 100%;
    box-sizing: border-box;
    background: #fbfbfb;
    width: 100%;
    min-width: 1280px;
}

body {
    font-family: var(--font);
    font-size: 16px;
    line-height: 18px;
    color: #000000;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

body * {
    box-sizing: border-box;
    font-family: inherit;
}

#root {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
}

main {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    margin-top: var(--header-height);
}

label {
    display: block;
    /*margin-bottom: 20px;*/
}

/*input,*/
/*input[type='button'],*/
/*textarea {*/
/*    color: #000000;*/
/*    font-size: 16px;*/
/*}*/

input,
input[type='button'],
textarea,
select,
button {
    outline: none;
    /*border: 1px solid #000000;*/
}

input[type='button'] {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}

input[type='number']::-webkit-outer-spin-button,
input[type='number']::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
/* For Firefox  */

input[type='number'] {
    -moz-appearance: textfield;
}

button {
    border: 0;
    background: transparent;
    cursor: pointer;
    border-radius: 25px;
}

textarea {
    resize: none;
}

input:not([type='checkbox']):not([type='radio']) {
    width: 100%;
}

input::placeholder,
textarea::placeholder {
    color: var(--dark-grey);
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
textarea:-webkit-autofill,
textarea:-webkit-autofill:hover,
textarea:-webkit-autofill:focus,
select:-webkit-autofill,
select:-webkit-autofill:hover,
select:-webkit-autofill:focus {
    -webkit-box-shadow: 0 0 0 1000px #fff inset;
    -webkit-transition: background-color 5000s ease-in-out 0s;
    transition: background-color 5000s ease-in-out 0s;
}

select {
    appearance: none;
    -webkit-appearance: none;
    background: #fff url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center right 22px;
    border-radius: 2px;
    border: 1px solid #000000;
    padding: 11px 44px 11px 22px;
    font-size: 16px;
    color: #000000;
    width: 263px;
    min-width: 263px;

    text-transform: capitalize;
    height: 44px;
}

select:disabled {
    background-color: #d6d6d6;
}

select:focus {
    border-color: var(--primary-color-active);
    color: var(--primary-color-active);
}

a {
    text-decoration: none;
    color: #000000;
    transition: color 0.4s;
}

a:hover {
    color: var(--hightlight-color);
}

.text-grey {
    color: var(--dark-grey);
}

h1,
.h1 {
    font-weight: bold;
    font-size: 20px;
    line-height: 24px;
}

h2,
.h2 {
    font-weight: 500;
    font-size: 18px;
    line-height: 22px;
    color: var(--dark-grey);
}

h3,
.h3 {
    font-weight: 500;
    font-size: 18px;
    line-height: 22px;
    /*color: var(--dark-grey);*/
}

h4 {
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    color: var(--dark-grey);
    /*margin-bottom: 20px;*/
}

h5 {
    font-weight: 500;
    font-size: 16px;
    line-height: 18px;
    /*color: var(--dark-grey);*/
    /*margin-bottom: 20px;*/
}

h6 {
    font-weight: 300;
    /*font-size: 14px;*/
    /*line-height: 16px;*/
    font-size: 14px;
    line-height: 16px;

    /*margin-bottom: 0;*/
    /*text-transform: uppercase;*/
}

h1,
h2,
h3,
h4,
h5,
h6 {
    margin-top: 0;
    margin-bottom: 0;
}

p {
    font-size: 16px;
    line-height: 18px;
}

svg * {
    /*transition: opacity 0.6s;*/
    /*shape-rendering: crispEdges; !* Forces the browser to snap to the nearest pixel *!*/
    /*vector-effect: non-scaling-stroke; !* Prevents the stroke from thickening if the SVG scales *!*/
}

.ps__rail-y {
    z-index: 60;
}

.ps__rail-x {
    z-index: 60;
    opacity: 1 !important;
}

.ps__rail-x > .ps__thumb-x {
    background: var(--primary-color);
    max-height: 8px;
    transition: max-height 0.2s;
}

.ps__rail-y > .ps__thumb-y {
    background: var(--primary-color);
    max-width: 8px;
    transition: max-width 0.2s;
}

.ps__rail-x:hover > .ps__thumb-x,
.ps__rail-x:focus > .ps__thumb-x,
.ps__rail-x.ps--clicking .ps__thumb-x {
    background: var(--primary-color-active) !important;
    max-height: 12px;
}

.ps__rail-y:hover > .ps__thumb-y,
.ps__rail-y:focus > .ps__thumb-y,
.ps__rail-y.ps--clicking .ps__thumb-y {
    max-width: 12px;
    background: var(--primary-color-active) !important;
}

.ps--active-x > .ps__rail-x,
.ps--active-y > .ps__rail-y {
    background-color: transparent !important;
}

.ps--active-x > .ps__rail-x:before,
.ps--active-y .ps__rail-y:before {
    content: '';
    display: block;
    bottom: 2px;
    left: 0;
    height: 2px;
    width: 100%;
    background: #e5e5e5;
    position: absolute;
    border-radius: 10px;
    transition: height 0.2s;
}

.ps--active-y .ps__rail-y:before {
    bottom: 0;
    right: 2px;
}

.ps__rail-x:hover:before,
.ps__rail-x:focus:before,
.ps__rail-x.ps--clicking:before {
    height: 6px;
}

.ps__rail-y:hover:before,
.ps__rail-y:focus:before,
.ps__rail-y.ps--clicking:before {
    width: 6px;
}

.ps__rail-x {
    transform: scaleX(0.9);
}

.ps__rail-y {
    transform: scaleY(0.9);
}

/* FOF GRAPH */
.fof-main,
.fund-main {
    transition: opacity 0.4s;
}
.fof-main {
    opacity: 0 !important;
}

.fof-active .fof-main {
    opacity: 1 !important;
}

.fof-active .fof-main.tip-link {
    opacity: 0.4 !important;
}

.fof-active .fund-main {
    opacity: 0 !important;
}

.highlight {
    color: var(--secondary-color);
}
.highlight-secondary {
    color: var(--primary-color);
}

th,
td {
    font-size: 13px;
}

.withInfo {
    position: relative;
}

.withInfo:after {
    position: absolute;
    top: 100%;
    bottom: -10px;
    background: var(--dark-grey);
    border-radius: 3px;
    color: #fff;
    font-size: 14px;
    font-weight: 400;
    padding: 3px 12px;
    min-width: 230px;
    min-height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    transition: opacity 0.4s;
    opacity: 0;
    pointer-events: none;
}

.withInfo:hover:not(.withInfoDisabled):after {
    pointer-events: auto;
    opacity: 1;
}

@media (max-width: 1919px) {
    :root {
        --header-height: 80px;
        --sidebar-expanded-width: 260px;

        /*--container-margin: 25px;*/
    }

    body {
        font-size: 14px;
        line-height: 16px;
    }

    p {
        font-size: 14px;
        line-height: 16px;
    }

    select {
        font-size: 15px;
        height: 40px;
        padding: 10px 22px;
    }

    h1,
    .h1 {
        font-size: 18px;
        line-height: 20px;
    }

    h2,
    .h2 {
        font-size: 16px;
        line-height: 18px;
    }

    h3,
    .h3 {
        font-size: 16px;
        line-height: 20px;

        /*font-size: 16px;*/
        /*line-height: 18px;*/
    }

    h4,
    .h4 {
        font-size: 14px;
        line-height: 16px;
    }

    h5,
    .h5 {
        font-size: 14px;
        line-height: 16px;
    }

    h6,
    .h6 {
        /*font-weight: 400;*/
        line-height: 14px;
        font-size: 12px;
    }

    th,
    td {
        font-size: 13px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;IACI,+BAA+B;IAC/B,qBAAqB;IACrB,oBAAoB;IACpB,kBAAkB;IAClB,uBAAuB;;IAEvB,0BAA0B;;IAE1B,wBAAwB;IACxB,+BAA+B;;IAE/B,8BAA8B;;IAE9B,0BAA0B;IAC1B,iCAAiC;;IAEjC,gCAAgC;IAChC,uCAAuC;;IAEvC,2BAA2B;;IAE3B,sBAAsB;;IAEtB,wBAAwB;;IAExB,4BAA4B;IAC5B,2CAA2C;;IAE3C,yBAAyB;IACzB,yBAAyB;IACzB,wBAAwB;;IAExB,sBAAsB;IACtB,4BAA4B;IAC5B,4BAA4B;;IAE5B,0BAA0B;;IAE1B,+BAA+B;IAC/B,+BAA+B;;IAE/B,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;;IAEI,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,wBAAwB;IACxB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,mCAAmC;IACnC,kCAAkC;AACtC;;AAEA;IACI,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,gCAAgC;AACpC;;AAEA;IACI,cAAc;IACd,uBAAuB;AAC3B;;AAEA,SAAS;AACT,wBAAwB;AACxB,aAAa;AACb,sBAAsB;AACtB,uBAAuB;AACvB,IAAI;;AAEJ;;;;;IAKI,aAAa;IACb,6BAA6B;AACjC;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;;IAEI,wBAAwB;IACxB,SAAS;AACb;AACA,iBAAiB;;AAEjB;IACI,0BAA0B;AAC9B;;AAEA;IACI,SAAS;IACT,uBAAuB;IACvB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;;IAEI,uBAAuB;AAC3B;;AAEA;;;;;;;;;IASI,2CAA2C;IAC3C,yDAAiD;IAAjD,iDAAiD;AACrD;;AAEA;IACI,gBAAgB;IAChB,wBAAwB;IACxB,oFAAmF;IACnF,kBAAkB;IAClB,yBAAyB;IACzB,4BAA4B;IAC5B,eAAe;IACf,cAAc;IACd,YAAY;IACZ,gBAAgB;;IAEhB,0BAA0B;IAC1B,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yCAAyC;IACzC,kCAAkC;AACtC;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;;IAEI,iBAAiB;IACjB,eAAe;IACf,iBAAiB;AACrB;;AAEA;;IAEI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;;IAEI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,qBAAqB;IACrB,eAAe;IACf,iBAAiB;;IAEjB,oBAAoB;IACpB,6BAA6B;AACjC;;AAEA;;;;;;IAMI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;IAC5B,qFAAqF;IACrF,iGAAiG;AACrG;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;IAChC,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,gCAAgC;IAChC,cAAc;IACd,0BAA0B;AAC9B;;AAEA;;;IAGI,kDAAkD;IAClD,gBAAgB;AACpB;;AAEA;;;IAGI,eAAe;IACf,kDAAkD;AACtD;;AAEA;;IAEI,wCAAwC;AAC5C;;AAEA;;IAEI,WAAW;IACX,cAAc;IACd,WAAW;IACX,OAAO;IACP,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,SAAS;IACT,UAAU;AACd;;AAEA;;;IAGI,WAAW;AACf;;AAEA;;;IAGI,UAAU;AACd;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,cAAc;AACd;;IAEI,wBAAwB;AAC5B;AACA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,6BAA6B;AACjC;AACA;IACI,2BAA2B;AAC/B;;AAEA;;IAEI,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,aAAa;IACb,4BAA4B;IAC5B,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,wBAAwB;IACxB,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;IACpB,UAAU;AACd;;AAEA;IACI;QACI,qBAAqB;QACrB,+BAA+B;;QAE/B,4BAA4B;IAChC;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,YAAY;QACZ,kBAAkB;IACtB;;IAEA;;QAEI,eAAe;QACf,iBAAiB;IACrB;;IAEA;;QAEI,eAAe;QACf,iBAAiB;IACrB;;IAEA;;QAEI,eAAe;QACf,iBAAiB;;QAEjB,mBAAmB;QACnB,qBAAqB;IACzB;;IAEA;;QAEI,eAAe;QACf,iBAAiB;IACrB;;IAEA;;QAEI,eAAe;QACf,iBAAiB;IACrB;;IAEA;;QAEI,oBAAoB;QACpB,iBAAiB;QACjB,eAAe;IACnB;;IAEA;;QAEI,eAAe;IACnB;AACJ","sourcesContent":[":root {\n    --light-grey-rgb: 214, 214, 214;\n    --light-grey: #d6d6d6;\n    --dark-grey: #7b848e;\n    /*border: #707070*/\n    --white-active: #fbfbfb;\n\n    --light-grey-blue: #f2f3f4;\n\n    --primary-color: #1650b4;\n    --primary-color-active: #0c3b8d;\n\n    --primary-color-light: #f0f3f7;\n\n    --secondary-color: #ff6f00;\n    --secondary-color-active: #bc5200;\n\n    --secondary-light-color: #16a9fd;\n    --secondary-light-color-active: #1294f0;\n\n    --hightlight-color: #1b53b1;\n\n    --alert-color: #cf3b30;\n\n    --success-color: #3b7f57;\n\n    --font: 'Roboto', sans-serif;\n    --font-secondary: 'Koh Santepheap', cursive;\n\n    --container-width: 1880px;\n    --container-padding: 30px;\n    --container-margin: 35px;\n\n    --header-height: 100px;\n    --header-padding-sides: 40px;\n    --header-padding-bottom: 0px;\n\n    --header-logo-width: 211px;\n\n    --sidebar-collapsed-width: 60px;\n    --sidebar-expanded-width: 300px;\n\n    --folder-gap: 50px;\n    --folder-item-gap: 20px;\n}\n\nhtml,\nbody {\n    margin: 0;\n    padding: 0;\n    min-height: 100%;\n    box-sizing: border-box;\n    background: #fbfbfb;\n    width: 100%;\n    min-width: 1280px;\n}\n\nbody {\n    font-family: var(--font);\n    font-size: 16px;\n    line-height: 18px;\n    color: #000000;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n}\n\nbody * {\n    box-sizing: border-box;\n    font-family: inherit;\n}\n\n#root {\n    display: flex;\n    flex-direction: column;\n    min-height: 100vh;\n}\n\nmain {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    margin-top: var(--header-height);\n}\n\nlabel {\n    display: block;\n    /*margin-bottom: 20px;*/\n}\n\n/*input,*/\n/*input[type='button'],*/\n/*textarea {*/\n/*    color: #000000;*/\n/*    font-size: 16px;*/\n/*}*/\n\ninput,\ninput[type='button'],\ntextarea,\nselect,\nbutton {\n    outline: none;\n    /*border: 1px solid #000000;*/\n}\n\ninput[type='button'] {\n    text-overflow: ellipsis;\n    overflow: hidden;\n    white-space: nowrap;\n}\n\ninput[type='number']::-webkit-outer-spin-button,\ninput[type='number']::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\n/* For Firefox  */\n\ninput[type='number'] {\n    -moz-appearance: textfield;\n}\n\nbutton {\n    border: 0;\n    background: transparent;\n    cursor: pointer;\n    border-radius: 25px;\n}\n\ntextarea {\n    resize: none;\n}\n\ninput:not([type='checkbox']):not([type='radio']) {\n    width: 100%;\n}\n\ninput::placeholder,\ntextarea::placeholder {\n    color: var(--dark-grey);\n}\n\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus,\ntextarea:-webkit-autofill,\ntextarea:-webkit-autofill:hover,\ntextarea:-webkit-autofill:focus,\nselect:-webkit-autofill,\nselect:-webkit-autofill:hover,\nselect:-webkit-autofill:focus {\n    -webkit-box-shadow: 0 0 0 1000px #fff inset;\n    transition: background-color 5000s ease-in-out 0s;\n}\n\nselect {\n    appearance: none;\n    -webkit-appearance: none;\n    background: #fff url('./assets/icons/chevron-down.svg') no-repeat center right 22px;\n    border-radius: 2px;\n    border: 1px solid #000000;\n    padding: 11px 44px 11px 22px;\n    font-size: 16px;\n    color: #000000;\n    width: 263px;\n    min-width: 263px;\n\n    text-transform: capitalize;\n    height: 44px;\n}\n\nselect:disabled {\n    background-color: #d6d6d6;\n}\n\nselect:focus {\n    border-color: var(--primary-color-active);\n    color: var(--primary-color-active);\n}\n\na {\n    text-decoration: none;\n    color: #000000;\n    transition: color 0.4s;\n}\n\na:hover {\n    color: var(--hightlight-color);\n}\n\n.text-grey {\n    color: var(--dark-grey);\n}\n\nh1,\n.h1 {\n    font-weight: bold;\n    font-size: 20px;\n    line-height: 24px;\n}\n\nh2,\n.h2 {\n    font-weight: 500;\n    font-size: 18px;\n    line-height: 22px;\n    color: var(--dark-grey);\n}\n\nh3,\n.h3 {\n    font-weight: 500;\n    font-size: 18px;\n    line-height: 22px;\n    /*color: var(--dark-grey);*/\n}\n\nh4 {\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 20px;\n    color: var(--dark-grey);\n    /*margin-bottom: 20px;*/\n}\n\nh5 {\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 18px;\n    /*color: var(--dark-grey);*/\n    /*margin-bottom: 20px;*/\n}\n\nh6 {\n    font-weight: 300;\n    /*font-size: 14px;*/\n    /*line-height: 16px;*/\n    font-size: 14px;\n    line-height: 16px;\n\n    /*margin-bottom: 0;*/\n    /*text-transform: uppercase;*/\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n    margin-top: 0;\n    margin-bottom: 0;\n}\n\np {\n    font-size: 16px;\n    line-height: 18px;\n}\n\nsvg * {\n    /*transition: opacity 0.6s;*/\n    /*shape-rendering: crispEdges; !* Forces the browser to snap to the nearest pixel *!*/\n    /*vector-effect: non-scaling-stroke; !* Prevents the stroke from thickening if the SVG scales *!*/\n}\n\n.ps__rail-y {\n    z-index: 60;\n}\n\n.ps__rail-x {\n    z-index: 60;\n    opacity: 1 !important;\n}\n\n.ps__rail-x > .ps__thumb-x {\n    background: var(--primary-color);\n    max-height: 8px;\n    transition: max-height 0.2s;\n}\n\n.ps__rail-y > .ps__thumb-y {\n    background: var(--primary-color);\n    max-width: 8px;\n    transition: max-width 0.2s;\n}\n\n.ps__rail-x:hover > .ps__thumb-x,\n.ps__rail-x:focus > .ps__thumb-x,\n.ps__rail-x.ps--clicking .ps__thumb-x {\n    background: var(--primary-color-active) !important;\n    max-height: 12px;\n}\n\n.ps__rail-y:hover > .ps__thumb-y,\n.ps__rail-y:focus > .ps__thumb-y,\n.ps__rail-y.ps--clicking .ps__thumb-y {\n    max-width: 12px;\n    background: var(--primary-color-active) !important;\n}\n\n.ps--active-x > .ps__rail-x,\n.ps--active-y > .ps__rail-y {\n    background-color: transparent !important;\n}\n\n.ps--active-x > .ps__rail-x:before,\n.ps--active-y .ps__rail-y:before {\n    content: '';\n    display: block;\n    bottom: 2px;\n    left: 0;\n    height: 2px;\n    width: 100%;\n    background: #e5e5e5;\n    position: absolute;\n    border-radius: 10px;\n    transition: height 0.2s;\n}\n\n.ps--active-y .ps__rail-y:before {\n    bottom: 0;\n    right: 2px;\n}\n\n.ps__rail-x:hover:before,\n.ps__rail-x:focus:before,\n.ps__rail-x.ps--clicking:before {\n    height: 6px;\n}\n\n.ps__rail-y:hover:before,\n.ps__rail-y:focus:before,\n.ps__rail-y.ps--clicking:before {\n    width: 6px;\n}\n\n.ps__rail-x {\n    transform: scaleX(0.9);\n}\n\n.ps__rail-y {\n    transform: scaleY(0.9);\n}\n\n/* FOF GRAPH */\n.fof-main,\n.fund-main {\n    transition: opacity 0.4s;\n}\n.fof-main {\n    opacity: 0 !important;\n}\n\n.fof-active .fof-main {\n    opacity: 1 !important;\n}\n\n.fof-active .fof-main.tip-link {\n    opacity: 0.4 !important;\n}\n\n.fof-active .fund-main {\n    opacity: 0 !important;\n}\n\n.highlight {\n    color: var(--secondary-color);\n}\n.highlight-secondary {\n    color: var(--primary-color);\n}\n\nth,\ntd {\n    font-size: 13px;\n}\n\n.withInfo {\n    position: relative;\n}\n\n.withInfo:after {\n    position: absolute;\n    top: 100%;\n    bottom: -10px;\n    background: var(--dark-grey);\n    border-radius: 3px;\n    color: #fff;\n    font-size: 14px;\n    font-weight: 400;\n    padding: 3px 12px;\n    min-width: 230px;\n    min-height: 25px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    box-sizing: border-box;\n    transition: opacity 0.4s;\n    opacity: 0;\n    pointer-events: none;\n}\n\n.withInfo:hover:not(.withInfoDisabled):after {\n    pointer-events: auto;\n    opacity: 1;\n}\n\n@media (max-width: 1919px) {\n    :root {\n        --header-height: 80px;\n        --sidebar-expanded-width: 260px;\n\n        /*--container-margin: 25px;*/\n    }\n\n    body {\n        font-size: 14px;\n        line-height: 16px;\n    }\n\n    p {\n        font-size: 14px;\n        line-height: 16px;\n    }\n\n    select {\n        font-size: 15px;\n        height: 40px;\n        padding: 10px 22px;\n    }\n\n    h1,\n    .h1 {\n        font-size: 18px;\n        line-height: 20px;\n    }\n\n    h2,\n    .h2 {\n        font-size: 16px;\n        line-height: 18px;\n    }\n\n    h3,\n    .h3 {\n        font-size: 16px;\n        line-height: 20px;\n\n        /*font-size: 16px;*/\n        /*line-height: 18px;*/\n    }\n\n    h4,\n    .h4 {\n        font-size: 14px;\n        line-height: 16px;\n    }\n\n    h5,\n    .h5 {\n        font-size: 14px;\n        line-height: 16px;\n    }\n\n    h6,\n    .h6 {\n        /*font-weight: 400;*/\n        line-height: 14px;\n        font-size: 12px;\n    }\n\n    th,\n    td {\n        font-size: 13px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
